import { forwardRef, InputHTMLAttributes } from 'react';
import { UseFormRegister } from 'react-hook-form';

interface CustomInputProps extends InputHTMLAttributes<HTMLInputElement> {
    required?: boolean;
    register?: UseFormRegister<any>;
}

const ToggleSwitch = forwardRef<HTMLInputElement, CustomInputProps>((props, ref) => {
    const { required, register, checked, onChange, ...inputProps } = props;

    return (
        <div className="flex items-center gap-3 font-light font-helveticaNeue text-p uppercase">
            <span>NO</span>
            <label className="relative inline-flex items-center cursor-pointer">
                <input
                    {...register}
                    {...inputProps}
                    ref={ref}
                    type="checkbox"
                    className="sr-only peer"
                    checked={checked}
                    onChange={onChange}
                    required={required}
                />
                <div className="w-12 h-6 bg-gray-200 rounded-full peer dark:bg-gray-700 peer-focus:ring-2 peer-focus:ring-primary peer-checked:after:translate-x-6 peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-primary"></div>
            </label>
            <span>YES</span>
        </div>
    );
});

ToggleSwitch.displayName = 'ToggleSwitch';

export default ToggleSwitch;
